<template>
  <div class="launchPlan">
    <div class="launchPlan_titleArea">
      <input
        v-model="name"
        class="input"
        @input="myInput"
      >
      <i class="el-icon-edit" />
    </div>
    <main class="launchPlan_main">
      <PromotionObjectives
        :promotion-objectives="promotionObjectives"
        :promotion-objectives1="promotionObjectives1"
        :option="launchPlan.promoted_object_type"
        :product="product"

        @setPromotion="$emit('setPromotion',$event)"
        @setname="setname"
      />
      <DeliveryPosition
        ref="DeliverycomPosition"
        :product="product"
        :pos_type="pos_type"
        :multislottype="multislottype"
        :campaign_type="launchPlan.campaign_type"
        @setDeliver="$emit('setDeliver',$event)"
        @setpostype="$emit('setpostype',$event)"
        @setarr="$emit('setarr',$event)"
        @setnameproducttype="$emit('setnameproducttype',$event)"
      />
      <PurchaseMethod />
      <PlannedBudget
        :daily_budget="launchPlan.daily_budget"
        :campaign="campaign"
        @setDailyBudget="$emit('setDailyBudget',$event)"
      />
    </main>
    <div class="launchPlan_buttonArea">
      <el-button
        type="primary"
        @click="$emit('nextStep')"
      >下一页</el-button>
    </div>
  </div>
</template>

<script>
import PromotionObjectives from './components/promotionObjectives.vue'
import DeliveryPosition from './components/deliveryPosition.vue'
import PurchaseMethod from './components/purchaseMethod.vue'
import PlannedBudget from './components/PlannedBudget.vue'
export default {
  components: {
    PromotionObjectives,
    DeliveryPosition,
    PurchaseMethod,
    PlannedBudget
  },
  props: {
    promotionObjectives: {
      type: Object
    },
    promotionObjectives1: {
      type: Array
    },
    product: {
      type: String
    },
    pos_type: {
      type: Number
    },
    multislottype: {
      type: Number
    },
    campaign: {
      type: Object
    },
    campaign_name: {
      default: ''
    },
    launchPlan: {
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      name: ''
    }
  },
  created() {
    this.name = this.campaign.cname
    console.log('product', this.product)
  },
  methods: {
    myInput(e) {
      this.$emit('campaignName', this.name)
    },
    setname(val) {
      console.log('val;;;', val)
      this.$emit('setname', val)
      if (this.$refs.DeliverycomPosition) {
        this.$refs.DeliverycomPosition.open(val)
      }
    }
  }
}
</script>

<style scoped lang="less">
.launchPlan {
  min-width: 1100px;
  width: 1100px;
  height: min-content;
  .launchPlan_titleArea {
    .input {
      width: 491px;
      border: none;
      box-shadow: none;
      background: none;
      font-size: inherit;
      line-height: 24px;
      padding: 0.3em;
      white-space: pre-wrap;
      border-radius: 3px;
      font-weight: bold;
      font-size: 17px;
      &:hover {
        box-shadow: inset 0 0 0 1px #bec0c2;
      }
    }
    .el-icon-edit {
      font-size: 16px;
      margin-left: 10px;
    }
  }

  .launchPlan_main {
    margin-top: 20px;
  }

  .launchPlan_buttonArea {
    margin-top: 10px;
    display: flex;
    justify-content: flex-end;
  }
}
</style>
